import React, { FC } from 'react';
import cn from 'classnames';
import { Money as MoneyType } from '../../../../../../../types';
import { useTheme } from '../../../../../../../theme';
import PriceItem from '../PriceItem/PriceItem';
import { useTranslation } from 'react-i18next';

interface Props {
	className?: string;
	price: MoneyType;
}

const TotalRefund: FC<Props> = ({ className, price }) => {
	const { t } = useTranslation('Refund');

	const { TotalRefund: css } = useTheme('Entities').Order.ExchangeRefundPriceDetails;

	return <PriceItem className={cn(css.root, className)} name={`${t('Refund amount')}:`} price={price} />;
};

export default TotalRefund;
